export const Z_LAYERS = {
  below: -1,
  base: 0,
  surface: 10,
  raised: 20,
  sticky: 30,
  chrome: 40,
  overlay: 60,
  flyout: 80,
  popover: 90,
  tooltip: 100,
  modalBackdrop: 110,
  modal: 120,
  toast: 130,
  max: 2_147_483_647,
} as const;

export type ZLayerToken = keyof typeof Z_LAYERS;
